import type { SxProps } from '@cast/design-system';
import { tokens } from '@cast/design-system';

export const tabsContainerSx: SxProps = {
  px: 24,
  pt: 24,
  pb: 0,
};

export const tabsSx: SxProps = {
  '& .MuiTabs-flexContainer': {
    gap: 8,
    borderBottom: 'none',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTab-root': {
    backgroundColor: tokens.theme.bg.structural.surfaceRaised,
    color: tokens.theme.fg.structural.secondary,
    border: '1px solid',
    borderColor: 'transparent',
    borderRadius: '4px',
    minHeight: 'auto',
    height: '20px',
    padding: '0 6px',
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: 500,
    '&:after': {
      display: 'none',
    },
    '&.Mui-selected': {
      backgroundColor: tokens.theme.bg.structural.surfaceRaised,
      color: tokens.theme.fg.structural.primary,
      border: '1px solid',
      borderColor: tokens.theme.border.structural.neutral,
      '&:hover': {
        backgroundColor: tokens.theme.bg.structural.surfaceRaised,
        color: tokens.theme.fg.structural.primary,
        '&:after': {
          display: 'none',
        },
      },
    },
    '&:hover:not(.Mui-selected)': {
      backgroundColor: tokens.theme.bg.structural.surfaceRaised,
      color: tokens.theme.fg.structural.secondary,
      '&:after': {
        display: 'none',
      },
    },
  },
};

export const yamlPreviewRootSx: SxProps = {
  position: 'initial',
  backgroundColor: tokens.theme.bg.structural.code,
  height: '100%',
  '& .DsPreviewYaml-Scroller': {
    overflowX: 'auto',
    overflowY: 'auto',
    '& .os-host': {
      overflowX: 'auto',
      overflowY: 'auto',
    },
    '& .os-viewport': {
      overflowX: 'auto',
      overflowY: 'auto',
    },
    '& .os-content': {
      minWidth: 'max-content',
    },
  },
};

export const yamlPreviewContainerSx: SxProps = {
  padding: 0,
  minWidth: 'max-content',
  width: 'max-content',
};
